/* istanbul ignore file */
import { useState, useEffect } from 'react';

// hook is currently only used in dev for the grid toggler
export function useKeyDownToggler(targetKey) {
  const [keyDown, setKeyDown] = useState(false);

  // Add event listener
  useEffect(() => {
    const downHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyDown(!keyDown);
      }
    };
    window.addEventListener('keydown', downHandler);
    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, [keyDown, targetKey]);

  return keyDown;
}
